import * as React from "react";
import { wafflesKeyColumnName } from "@app/shared/waffles"
import { JSX } from "react";

export default interface InspectionProfileTableData {
  [wafflesKeyColumnName]: string;
  reference: JSX.Element;
  result: React.ReactNode;
  source: React.ReactNode;
  title: string | JSX.Element;
}